'use strict';

define([
    'jquery',
    'underscore',
    'moment',
    'jscookie',
    'snackbar',
    'selectize',
    'async',
    'moment_timezone',
    'velocity',
    'formvalidator',
    'chart'
],function ($, _, moment, Cookies, Snackbar, Selectize) {
    var helpers = {};

    var easingSwiftOut = [0.4, 0, 0.2, 1];

    helpers.loaded = false;
    helpers.init = function (reload) {
        var self = this;
        if (reload) self.loaded = false;
        if (self.loaded) {
            console.warn('Helpers already loaded. Possible double load.')
        }

        self.setTimezone();

        self.resizeFullHeight();
        self.formvalidator();

        self.UI.selectize();

        var layout = self.onWindowResize();
        // Initial Call to Load Layout
        layout();
        $(window).resize(layout);

        self.loaded = true;
    };

    helpers.jsPreventDefault = function () {
        $('.js-prevent-default').each(function () {
            $(this).on('click', function (event) {
                event.preventDefault()
            })
        })
    };

    helpers.hideAllpDropDowns = function () {
        $('a[data-notifications]').each(function () {
            var drop = $('#' + $(this).attr('data-notifications'));
            if (drop.hasClass('pDropOpen')) {
                drop.removeClass('pDropOpen')
            }
        })
    };

    helpers.onWindowResize = function () {
        var self = this;
        return _.debounce(function () {
            $('body > .side-nav-sub.tether-element').each(function () {
                $(this).remove()
            });

            self.resizeFullHeight();
            self.hideAllpDropDowns();

            self.resizeDataTables('#table-maintenance');
            //self.resizeDataTables('.tagsList');
        }, 100)
    };

    helpers.resizeDataTables = function (selector, hasFooter) {
        if (_.isUndefined(selector)) {
            return true
        }

        if (_.isUndefined(hasFooter)) {
            hasFooter = false
        }

        $(document).ready(function () {
            var $selector = $(selector);
            var scroller = $selector.find('.dataTables_scrollBody');
            if (scroller.length !== 0) {
                var tableHead = $selector.find('.dataTables_scrollHead');
                var optionsHead = $selector.find('.table-options');
                var hasFilter = $selector.find('.dataTables_filter');
                var headHeight = 0;
                if (optionsHead.length !== 0) {
                    headHeight = optionsHead.height()
                } else if (hasFilter.length !== 0) {
                    headHeight = hasFilter.height()
                }
                var footerHeight = 0;
                if (hasFooter) {
                    footerHeight = tableHead.height()
                }
                scroller.css({
                    height: $selector.height() - tableHead.height() - headHeight - footerHeight + 'px'
                })
            }
        })
    };

    helpers.resizeFullHeight = function () {
        var ele = $('.full-height');
        $.each(ele, function () {
            var self = $(this);
            ele.ready(function () {
                var h = $(window).height();
                if (self.css('borderTopStyle') === 'solid') {
                    h = h - 1
                }

                var dataOffset = self.attr('data-offset');
                if (!_.isUndefined(dataOffset)) {
                    h = h - dataOffset
                }

                // self.css('overflow', 'hidden');
                self.height(h - self.offset().top)
            })
        })
    };

    helpers.UI = {};

    helpers.UI.showSnackbar = function () {
        if (arguments.length === 1 && _.isObject(arguments[0])) {
            return helpers.UI.showSnackbar_.apply(this, arguments)
        }
        return helpers.UI.showSnackbar__.apply(this, arguments)
    };

    helpers.UI.showSnackbar_ = function (options) {
        Snackbar.show(options)
    };

    helpers.UI.showSnackbar__ = function (text, error) {
        if (_.isUndefined(error) || _.isNull(error)) {
            error = false
        }

        var actionText = '#4CAF50';

        if (error) {
            actionText = '#FF4835';
        }

        Snackbar.show({
            pos: 'top-right',
            text: text,
            actionTextColor: actionText
        })
    };

    helpers.UI.closeSnackbar = function () {
        //Snackbar.close()
    };

    helpers.setTimezone = function () {
        var $timezone = $('#__timezone');
        var timezone
        if ($timezone.length < 1) {
            Cookies.set('$ihelp:timezone', 'America/New_York')
        } else {
            timezone = Cookies.get('$ihelp:timezone');
            var __timezone = $timezone.text();
            if (!timezone) {
                Cookies.set('$ihelp:timezone', __timezone)
            } else if (timezone !== __timezone) {
                Cookies.set('$ihelp:timezone', __timezone)
            }
        }

        timezone = Cookies.get('$ihelp:timezone');

        moment.tz.setDefault(timezone);
        $timezone.remove()
    };

    helpers.getTimezone = function () {
        var timezone = Cookies.get('$ihelp:timezone');
        if (!timezone) {
            timezone = 'America/New_York'
        }

        return timezone
    };

    helpers.formatCurrency = function(amount){
        // Create USD currency formatter.
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
        });
        var out = formatter.format(amount);
        return out;
    };

    helpers.getTimeFormat = function () {
        if (window.trudeskSettingsService) {
            return window.trudeskSettingsService.getSettings().timeFormat.value
        }

        return 'hh:mma'
    };

    helpers.formvalidator = function () {
        $.validate({
            errorElementClass: 'uk-form-danger',
            errorMessageClass: 'uk-form-danger'
        })
    };

    helpers.getCalendarDate = function (date) {
        moment.updateLocale('en', {
            calendar: {
                sameDay: '[Today at] LT',
                lastDay: '[Yesterday at] LT',
                nextDay: '[Tomorrow at] LT',
                lastWeek: '[Last] ddd [at] LT',
                nextWeek: 'ddd [at] LT',
                sameElse: helpers.getShortDateFormat()
            }
        });
        return moment
            .utc(date)
            .tz(this.getTimezone())
            .calendar()
    };

    helpers.getShortDateFormat = function () {
        if (window.trudeskSettingsService) {
            return window.trudeskSettingsService.getSettings().shortDateFormat.value
        }

        return 'MM/DD/YYYY'
    };

    helpers.getLongDateFormat = function () {
        if (window.trudeskSettingsService) {
            return window.trudeskSettingsService.getSettings().longDateFormat.value
        }

        return 'MMM DD, YYYY'
    };

    helpers.formatDate = function (date, format) {
        var timezone = this.getTimezone();
        if (!timezone) {
            timezone = 'America/New_York'
        }

        return moment
            .utc(date)
            .tz(timezone)
            .format(format)
    };

    helpers.UI.selectize = function (parent) {
        // selectize plugins
        if (typeof $.fn.selectize !== 'undefined') {
            Selectize.define('dropdown_after', function () {
                var self = this
                self.positionDropdown = function () {
                    var $control = this.$control;

                    var position = $control.position();

                    var paddingLeft = position.left;

                    var paddingTop = position.top + $control.outerHeight(true) + 32;

                    this.$dropdown.css({
                        width: $control.outerWidth(),
                        top: paddingTop,
                        left: paddingLeft
                    })
                }
            })
        }

        var $selectize = parent ? $(parent).find('select') : $('[data-md-selectize],.data-md-selectize');

        $selectize.each(function () {
            var $this = $(this);
            if (!$this.hasClass('selectized')) {
                var thisPosBottom = $this.attr('data-md-selectize-bottom');
                var posTopOffset = $this.attr('data-md-selectize-top-offset');
                var closeOnSelect =
                    $this.attr('data-md-selectize-closeOnSelect') !== 'undefined'
                        ? $this.attr('data-md-selectize-closeOnSelect')
                        : false;
                $this.after('<div class="selectize_fix"></div>').selectize({
                    plugins: ['remove_button'],
                    hideSelected: true,
                    dropdownParent: 'body',
                    closeAfterSelect: closeOnSelect,
                    onDropdownOpen: function ($dropdown) {
                        $dropdown.hide().velocity('slideDown', {
                            begin: function () {
                                if (typeof thisPosBottom !== 'undefined') {
                                    $dropdown.css({ 'margin-top': '0' });
                                    if (typeof posTopOffset !== 'undefined') {
                                        $dropdown.css({ 'margin-top': posTopOffset + 'px' })
                                    }
                                }
                            },
                            duration: 200,
                            easing: easingSwiftOut
                        })
                    },
                    onDropdownClose: function ($dropdown) {
                        $dropdown.show().velocity('slideUp', {
                            complete: function () {
                                if (typeof thisPosBottom !== 'undefined') {
                                    $dropdown.css({ 'margin-top': '' })
                                }

                                if (closeOnSelect) {
                                    $($dropdown)
                                        .prev()
                                        .find('input')
                                        .blur()
                                }
                            },
                            duration: 200,
                            easing: easingSwiftOut
                        })
                    }
                })
            }
        });

        // dropdowns
        var $selectizeInline = $('[data-md-selectize-inline]');

        $selectizeInline.each(function () {
            var $this = $(this);
            if (!$this.hasClass('selectized')) {
                var thisPosBottom = $this.attr('data-md-selectize-bottom');
                var posTopOffset = $this.attr('data-md-selectize-top-offset');
                var closeOnSelect =
                    $this.attr('data-md-selectize-closeOnSelect') !== 'undefined'
                        ? $this.attr('data-md-selectize-closeOnSelect')
                        : false;
                var maxOptions =
                    $this.attr('data-md-selectize-maxOptions') !== 'undefined' ? $this.attr('data-md-selectize-maxOptions') : 1000;
                $this
                    .after('<div class="selectize_fix"></div>')
                    .closest('div')
                    .addClass('uk-position-relative')
                    .end()
                    .selectize({
                        plugins: ['dropdown_after', 'remove_button'],
                        dropdownParent: $this.closest('div'),
                        hideSelected: true,
                        closeAfterSelect: closeOnSelect,
                        maxOptions: maxOptions,
                        onDropdownOpen: function ($dropdown) {
                            $dropdown.hide().velocity('slideDown', {
                                begin: function () {
                                    if (typeof thisPosBottom !== 'undefined') {
                                        $dropdown.css({ 'margin-top': '0' });
                                        if (typeof posTopOffset !== 'undefined') {
                                            $dropdown.css({ 'margin-top': posTopOffset + 'px' })
                                        }
                                    }
                                },
                                duration: 200,
                                easing: easingSwiftOut
                            })
                        },
                        onDropdownClose: function ($dropdown) {
                            $dropdown.show().velocity('slideUp', {
                                complete: function () {
                                    if (typeof thisPosBottom !== 'undefined') {
                                        $dropdown.css({ 'margin-top': '' })
                                    }

                                    if (closeOnSelect) {
                                        $($dropdown)
                                            .prev()
                                            .find('input')
                                            .blur()
                                    }
                                },
                                duration: 200,
                                easing: easingSwiftOut
                            })
                        }
                    })
            }
        })
    };
    return helpers
});